import { Table } from 'react-bootstrap';
import imageLoader from "../images/loader/loaderrrr.gif"

const SharedTable = ({ columns = [], data = [] , loader = false }) => {
    return (
        <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
            <Table bordered striped className="align-middle graphic-table">
            <thead>
                <tr>
                    {
                        columns.map((item, index) => (
                            <th key={index}>
                                {item?.name}
                                {/* <span style={{cursor : "pointer"}}>
                                    <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    fill="currentColor"
                                    className="bi bi-chevron-expand ms-2"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        filerule="evenodd"
                                        d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                                    />
                                </svg>
                                </span> */}
                            </th>
                        ))
                    }
                </tr>
            </thead>
            <tbody>
                {
                    loader ? (
                        <div style={{width : "80vw"}} className="d-flex justify-content-center align-items-center py-5">
                            <img src={imageLoader} alt="Loading..." style={{ height: "80px" }} />
                        </div>
                    ) : (
                        <>
                            {data?.length > 0 ? (
                                data.map((row, rowIndex) => (
                                    <tr key={rowIndex}>
                                        {columns.map((col, colIndex) => {
                                            return (
                                                <td key={colIndex}>
                                                    {col.render(row)}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={columns.length} className="text-center">
                                        No data found
                                    </td>
                                </tr>
                            )}
                        </>
                    )
                }

            </tbody>
        </Table>
        </div>
    )
}

export default SharedTable;